import { BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS } from 'store/ducks/search/types';

export const fetchSymphonySearchComponents = () => ({
  type: BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS
});
